/** Parse a plain "(xmin, ymin, xmax, ymax)" string → pixel ints, or null. */
export function parseBboxString(raw) {
  if (typeof raw !== "string") return null;
  const m = raw
    .trim()
    .match(
      /^\(\s*([+-]?\d*\.?\d+)\s*,\s*([+-]?\d*\.?\d+)\s*,\s*([+-]?\d*\.?\d+)\s*,\s*([+-]?\d*\.?\d+)\s*\)$/
    );
  if (!m) return null;
  const coords = [m[1], m[2], m[3], m[4]].map(Number);
  if (coords.some(n => Number.isNaN(n))) return null;
  return {
    x_min: Math.round(coords[0]),
    y_min: Math.round(coords[1]),
    x_max: Math.round(coords[2]),
    y_max: Math.round(coords[3]),
  };
}

/** Format pixel bounds as the DPM wire string "(x, y, x, y)". */
export function formatBboxString({ x_min, y_min, x_max, y_max }) {
  return `(${x_min}, ${y_min}, ${x_max}, ${y_max})`;
}

/** Image.focus params; omit any coord → {} (Unity full-texture focus). */
export function imageFocusParams(x_min, y_min, x_max, y_max) {
  const coords = [x_min, y_min, x_max, y_max];
  if (!coords.every(n => n != null)) return {};
  return {
    x_min: Math.round(x_min),
    y_min: Math.round(y_min),
    x_max: Math.round(x_max),
    y_max: Math.round(y_max),
  };
}
